import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=ff0b7882&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b7882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff0b7882')) {
      api.createRecord('ff0b7882', component.options)
    } else {
      api.reload('ff0b7882', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=ff0b7882&scoped=true", function () {
      api.rerender('ff0b7882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/leads/Create.vue"
export default component.exports